import React, { useState, useEffect } from 'react'
//import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Loadingcomponent from "../loader/loadingcomponent";
import { Swiper, SwiperSlide } from 'swiper/react';
import {
  isContainAlphabet, setItemInSessionStorage
} from "../../services/common/utils";
import { useNavigate } from 'react-router-dom';
import { getImgSrc } from '../../services/common/CommonUtils';
import { useDispatch } from 'react-redux';
import { setCdrPlanType, setCdrtransid } from '../../reducer/cdrSlice';

const MessageModal = ({
  type = "1",
  show,
  toggleModal,
  title = '',
  message,
  handleOk,
  handleCancel,
  handleConfirm,
  cancel,
  confirm,
  loading,
  pBtnText,
  actionText,
  handleAction,
  showPremium,
  handleSubscribe,
  cdrCardsData,
  disableDispatch = false
}) => {
  const { t } = useTranslation();
  const posBtnText = pBtnText ? pBtnText : 'continue';
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = (e, item)=>{
    dispatch(setCdrtransid(''));

    if(!disableDispatch){
      dispatch(setCdrPlanType(item?.title?.toUpperCase()))
    }

    if(handleSubscribe){
      handleSubscribe(e);
    }else{
      // setItemInSessionStorage('CDR', e.target.innerText);
      navigate('/verification')
    }
    // if(!showPremium){
    // navigate('/'+item?.redirectUrl)
    // }else{
    //   handleSubscribe(e);
    // }
  } 

  return (
    <Modal
    show={show}
    backdrop="true"
    onHide={toggleModal}
    className="modal fade sprint14-modal002 sp16-center-modal show sprint17-packs-comp"
  // onHide={toggleMessageModal}
  // dialogClassName="modal-dialog-centered"
  >
    {/* <button type="button" className="btn-close sprint14-popup-close sprint16-popup-close" aria-label="Close">
                  <img src={process.env.PUBLIC_URL + "/assets/images/sprint14/popup-close-icon.svg"} alt="" title="" 
                  // onClick={()=>{setFalg(false)}}
                  />
               </button> */}
    <Modal.Body>
      <div className="sp16-delete-popup-comp sp17-delete-popup-comp">
        <div className='sprint16-pedia-swiper'>
          <Swiper
            // className="column_swiper_1"
            // className="column_swiper_1 swiper_vertical_slide"
            spaceBetween={12}
            //slidesPerView={2}
            breakpoints={{
              768:{
                slidesPerView: 2,
              },
              0:{
                slidesPerView:1.2
              }
            }}
          // grid={{ rows: 3, fill: "row" }}
          // modules={[Grid, Pagination]}
          >
            {cdrCardsData?.length > 0 && cdrCardsData?.map(item => {
              return (
                <SwiperSlide>

                  {/* pedia-card */}
                  <div className='sprint16-pedia-cards7'>
                    <div className='sprint16-pedia-row'>
                      <div className='sprint16-pedia-card'>

                        <div className='sprint16-pedia-cont'>

                          <div className='sprint17-pack-card'>
                            <div className='sprint17-pack-heading'>
                              <h6>{item?.title}</h6> 
                              {item?.icon && <img src={getImgSrc(item?.icon, true)} />}
                            </div>
                            <div className='sprint17-pack-content'>


                              <div className="sprint17-verifi-sec01 modal-popup-radio-btns">
                                {item?.meta?.map(obj => (
                                <div>
                                  <input id="radio-01" class="radio-custom checked" name="radio-group" type="checkbox" checked={obj?.select === true ? true : false} disabled/>
                                  <label for="radio-01" class="radio-custom-label">{obj?.title} </label>
                                </div>
                                ))}

                              </div>
                            </div>
                          </div>

                          <div className='sprint17-pack-price'>
                          <div>
                            {item?.price && <label>{item?.kdtext} {" "}{item?.price}{item?.validity ? "/"+ item?.validity : ''}</label>}
                            </div>
                            <div className="right-arrow-btn" onClick={(e)=>handleClick(e, item)}>
                              <button style={{background: item?.button_bgcolor ?? '#ED1C24', color: item?.button_color ?? "#FFFFFF"}} class="custom_btn custom_btn_primary btn_block sp16_custom_btn" >{item?.button_text}</button>
                            </div>
                          </div>

                        </div>

                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              )
            })}
          </Swiper>
        </div>
      </div>
    </Modal.Body>
  </Modal>
  );

};
export default MessageModal;